import React from "react";
import { Trans } from "react-i18next";
import ContactDetails from "./ContactDetails";
import { CurrencySymbol, formatCurrency } from "services/util";
import { DocumentTypeMapping } from "pages/Xero/Quotes/constants/ConvertToInvoiceButton";

export const MainHeader = ({
    item,
    client,
    company,
    settings,
    t,
    doc_name,
    hideAttention,
    children,
    logo,
    taxed=true,
    qrCode,
    header,
}) => {
    company = {
        ...company,
        Addresses: company?.Addresses?.map((address, index) =>{
            return { ...address, AddressLine3: address.AddressLine3 || settings.plot_number, AddressLine4: address.AddressLine4 ||settings.building_number }
        })
    };
    return (
        <>
        <div className="top row justify-content-end mb-2 flex-column-reverse">
            {logo && (
                <div className="col-12 d-flex justify-content-end">
                    <img style={{ maxHeight: 150 }} src={logo} alt="logo" />
                </div>
            )}
        </div>
        <div className={`row main my-3`}>
            <div className= {qrCode? "col-3":"col-4"}>
                <div className="mb-2">
                    <h4 >
                        <strong><Trans>{DocumentTypeMapping[item.DocumentType] || doc_name}</Trans></strong>
                    </h4>
                </div>
                {/* <div className="">
                    <Trans>To:</Trans>
                </div> */}
                <ContactDetails t={t} contact={client} hideAttention={hideAttention} />

                {client.TaxNumber &&
                    <div>
                        <p className="my-0 py-0 font-weight-bold"><Trans>VAT</Trans>: {client.TaxNumber}</p>
                    </div>
                }
                {(client.RegistrationNumber || client.CompanyNumber) &&
                    <div>
                        <p className="my-0 py-0 font-weight-bold"><Trans>CRN</Trans>: {client.RegistrationNumber || client.CompanyNumber}</p>
                    </div>
                }
            </div>

            {qrCode && (
                <div className="qr-code col-3 p-0">
                    <img alt="QR code" src={qrCode} style={{ width: "100%", height: "auto" }} className="rounded border text-center" />
                </div>
            )}

            <div className={qrCode? "col-3":"col-4"} >
                {children}
            </div>

            <div className={qrCode? "col-3":"col-4"}>
                {header ? (
                    <div style={{ whiteSpace: "pre-line" }}>{header}</div>
                ) : (
                    <ContactDetails t={t} contact={company} hideAttention={hideAttention} />
                )}
                {!header && company.TaxNumber &&
                    <div>
                        <p className="my-0 py-0 font-weight-bold"><Trans>VAT</Trans>: {company.TaxNumber}</p>
                    </div>
                }
                {!header && (company.RegistrationNumber || company.CompanyNumber) &&
                    <div>
                        <p className="my-0 py-0 font-weight-bold"><Trans>CRN</Trans>: {company.RegistrationNumber || company.CompanyNumber}</p>
                    </div>
                }
                {item.Invoice &&
                    <div className="my-3">
                        <div className="border-dark border-top border-bottom p-2 font-weight-bold d-flex justify-content-end">
                            <span className="mr-5">
                                <Trans>Total</Trans> <CurrencySymbol currency={item.Invoice.CurrencyCode}/>
                            </span>{" "}
                            <span>{formatCurrency(item.Amount)}</span>
                        </div>
                    </div>
                    
                }
            </div>
        </div>
    </>
    )
};

export default MainHeader;
